module.exports = __webpack_public_path__ + "static/img/erweima.3c4561c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erweima.jpg
// module id = 5pkz
// module chunks = 1